import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import Loadable from 'react-loadable'
// import Toast from './layout/Toast'
// components
import HeartLoading from './components/widgets/Loading/HeartLoading'
// styles
// import '../styles/main.scss'

const IframeMedicalCalendar = Loadable({loader: () => import(/* webpackChunkName: "medico-calendar" */ './components/pages/Iframe/MedicalCalendar'), loading: HeartLoading })
const App = Loadable({loader: () => import(/* webpackChunkName: "app" */ './App'), loading: HeartLoading })

class MainRouter extends Component {

  /*state = {
    loading: true,
  }

  componentDidMount() {
    this.setState({ loading: false })
    document.getElementById("body").classList.remove('unresolved')
  }*/

  render() {

    /*const { loading } = this.state

    if( loading ) {
      return null
    }*/

    return (
      <>
        <Switch>
          <Route exact path='/public/medical-calendar' component={IframeMedicalCalendar}/>
          <Route path='*' component={App}/>
        </Switch>
        {/*<Toast/>*/}
      </>
    );
  }
}

export default MainRouter
